import React from 'react';

export const ChevronRight = ({
  className,
  color,
  width="5",
  height="7"
}: {
  className?: string;
  color?: string;
  width?: string;
  height?: string
}) => (
  <svg
    width="5"
    height="7"
    viewBox="0 0 5 7"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.430846 0.414525C0.376769 0.468492 0.333867 0.532594 0.304594 0.603161C0.275322 0.673729 0.260254 0.749377 0.260254 0.825776C0.260254 0.902174 0.275322 0.977822 0.304594 1.04839C0.333867 1.11896 0.376769 1.18306 0.430846 1.23703L2.69418 3.50036L0.430846 5.76369C0.321776 5.87276 0.260501 6.02069 0.260501 6.17494C0.260501 6.32919 0.321776 6.47712 0.430846 6.58619C0.539917 6.69526 0.687848 6.75654 0.842096 6.75654C0.996345 6.75654 1.14428 6.69526 1.25335 6.58619L3.93085 3.90869C3.98492 3.85473 4.02783 3.79062 4.0571 3.72006C4.08637 3.64949 4.10144 3.57384 4.10144 3.49744C4.10144 3.42104 4.08637 3.3454 4.0571 3.27483C4.02783 3.20426 3.98492 3.14016 3.93085 3.08619L1.25335 0.408692C1.03168 0.187025 0.658346 0.187025 0.430846 0.414525Z"
      fill="#5E6C84"
    />
  </svg>
);
